// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Styles for VerificationModal component
 */

.verification-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.verification-modal {
  background: white;
  border-radius: 12px;
  max-width: 500px;
  width: 90%;
  max-height: 80vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  position: relative;
}

.verification-modal-header {
  padding: 20px;
  border-bottom: 1px solid #e5e5e5;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.verification-modal-header h2 {
  margin: 0;
  font-size: 20px;
  color: #333;
}

.verification-modal-close {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s;
}

.verification-modal-close:hover {
  color: #000;
}

.verification-modal-content {
  flex: 1;
  padding: 20px;
  overflow-y: auto;
}

.verification-modal-footer {
  padding: 20px;
  border-top: 1px solid #e5e5e5;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

/* Accept/Reject screen for incoming requests */
.verification-accept-screen {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 20px;
  text-align: center;
}

.verification-accept-icon {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 40px;
  margin-bottom: 20px;
  box-shadow: 0 4px 20px rgba(102, 126, 234, 0.3);
}

.verification-accept-screen h3 {
  margin: 0 0 15px 0;
  font-size: 22px;
  color: #333;
}

.verification-accept-message {
  font-size: 16px;
  color: #666;
  margin: 0 0 10px 0;
}

.verification-accept-message strong {
  color: #333;
  font-weight: 600;
}

.verification-accept-description {
  font-size: 14px;
  color: #999;
  margin: 0 0 30px 0;
}

.verification-accept-actions {
  display: flex;
  gap: 12px;
  width: 100%;
  max-width: 300px;
}

.verification-accept-actions .btn {
  flex: 1;
  padding: 12px 24px;
  font-size: 15px;
}

/* Loading state */
.verification-loading,
.verification-ready,
.verification-verifying {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 20px;
  text-align: center;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 3px solid #f0f0f0;
  border-top: 3px solid #007bff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 20px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* SAS Emoji Verification */
.verification-sas-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.verification-sas-instructions {
  margin-bottom: 30px;
  font-size: 16px;
  color: #666;
  text-align: center;
}

.verification-sas-emojis {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(80px, 1fr));
  gap: 15px;
  width: 100%;
  max-width: 400px;
  margin-bottom: 30px;
}

.verification-sas-emoji {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
  background: #f8f9fa;
  border-radius: 8px;
  transition: background-color 0.2s;
}

.verification-sas-emoji:hover {
  background: #e9ecef;
}

.verification-sas-emoji .emoji {
  font-size: 32px;
  margin-bottom: 5px;
}

.verification-sas-emoji .name {
  font-size: 12px;
  color: #666;
  text-align: center;
}

.verification-sas-actions {
  display: flex;
  gap: 10px;
}

/* QR Code Verification */
.verification-qr-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.verification-qr-instructions {
  margin-bottom: 20px;
  font-size: 16px;
  color: #666;
}

.verification-qr-code {
  margin-bottom: 20px;
}

.qr-placeholder {
  width: 256px;
  height: 256px;
  background: #f0f0f0;
  border: 2px solid #ddd;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  color: #999;
  font-size: 14px;
}

.verification-qr-alternative {
  font-size: 14px;
  color: #666;
}

/* Scan QR */
.verification-scan-qr {
  text-align: center;
  padding: 40px 20px;
}

.verification-scan-qr input {
  margin-top: 20px;
  width: 100%;
  max-width: 300px;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

/* Complete/Error/Cancel states */
.verification-complete,
.verification-cancelled,
.verification-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 20px;
  text-align: center;
}

.success-icon {
  width: 60px;
  height: 60px;
  background: #28a745;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 30px;
  margin-bottom: 20px;
}

.warning-icon {
  font-size: 48px;
  margin-bottom: 20px;
}

.error-icon {
  font-size: 48px;
  margin-bottom: 20px;
}

.verification-error-message {
  background: #f8d7da;
  color: #721c24;
  padding: 10px 15px;
  border-radius: 4px;
  margin-bottom: 20px;
}

/* Modal loading overlay */
.verification-modal-loading {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
}

/* Button styles */
.btn {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.btn-primary {
  background: #007bff;
  color: white;
}

.btn-primary:hover:not(:disabled) {
  background: #0056b3;
}

.btn-secondary {
  background: #6c757d;
  color: white;
}

.btn-secondary:hover:not(:disabled) {
  background: #545b62;
}

.btn-success {
  background: #28a745;
  color: white;
}

.btn-success:hover:not(:disabled) {
  background: #218838;
}

.btn-danger {
  background: #dc3545;
  color: white;
}

.btn-danger:hover:not(:disabled) {
  background: #c82333;
}

/* Dark theme support */
@media (prefers-color-scheme: dark) {
  .verification-modal {
    background: #1e1e1e;
    color: #e0e0e0;
  }

  .verification-modal-header {
    border-bottom-color: #333;
  }

  .verification-modal-header h2 {
    color: #e0e0e0;
  }

  .verification-modal-close {
    color: #999;
  }

  .verification-modal-close:hover {
    color: #fff;
  }

  .verification-modal-footer {
    border-top-color: #333;
  }

  .verification-accept-screen h3 {
    color: #e0e0e0;
  }

  .verification-accept-message {
    color: #b0b0b0;
  }

  .verification-accept-message strong {
    color: #fff;
  }

  .verification-accept-description {
    color: #888;
  }

  .verification-sas-emoji {
    background: #2a2a2a;
  }

  .verification-sas-emoji:hover {
    background: #333;
  }

  .qr-placeholder {
    background: #2a2a2a;
    border-color: #444;
    color: #666;
  }

  .verification-scan-qr input {
    background: #2a2a2a;
    border-color: #444;
    color: #e0e0e0;
  }

  .verification-error-message {
    background: #5a1e1e;
    color: #f8d7da;
  }

  .verification-modal-loading {
    background: rgba(30, 30, 30, 0.9);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/verification/VerificationModal.css"],"names":[],"mappings":"AAAA;;EAEE;;AAEF;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,OAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,kBAAkB;EAClB,eAAe;AACjB;;AAEA,kBAAkB;AAClB;;;EAGE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,0DAA0D;EAC1D,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,iCAAiC;AACjC;;;EAGE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE;IACE,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,iCAAiC;EACnC;AACF","sourcesContent":["/**\n * Styles for VerificationModal component\n */\n\n.verification-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n}\n\n.verification-modal {\n  background: white;\n  border-radius: 12px;\n  max-width: 500px;\n  width: 90%;\n  max-height: 80vh;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);\n  position: relative;\n}\n\n.verification-modal-header {\n  padding: 20px;\n  border-bottom: 1px solid #e5e5e5;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.verification-modal-header h2 {\n  margin: 0;\n  font-size: 20px;\n  color: #333;\n}\n\n.verification-modal-close {\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: #666;\n  padding: 0;\n  width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: color 0.2s;\n}\n\n.verification-modal-close:hover {\n  color: #000;\n}\n\n.verification-modal-content {\n  flex: 1;\n  padding: 20px;\n  overflow-y: auto;\n}\n\n.verification-modal-footer {\n  padding: 20px;\n  border-top: 1px solid #e5e5e5;\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n}\n\n/* Accept/Reject screen for incoming requests */\n.verification-accept-screen {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 40px 20px;\n  text-align: center;\n}\n\n.verification-accept-icon {\n  width: 80px;\n  height: 80px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 40px;\n  margin-bottom: 20px;\n  box-shadow: 0 4px 20px rgba(102, 126, 234, 0.3);\n}\n\n.verification-accept-screen h3 {\n  margin: 0 0 15px 0;\n  font-size: 22px;\n  color: #333;\n}\n\n.verification-accept-message {\n  font-size: 16px;\n  color: #666;\n  margin: 0 0 10px 0;\n}\n\n.verification-accept-message strong {\n  color: #333;\n  font-weight: 600;\n}\n\n.verification-accept-description {\n  font-size: 14px;\n  color: #999;\n  margin: 0 0 30px 0;\n}\n\n.verification-accept-actions {\n  display: flex;\n  gap: 12px;\n  width: 100%;\n  max-width: 300px;\n}\n\n.verification-accept-actions .btn {\n  flex: 1;\n  padding: 12px 24px;\n  font-size: 15px;\n}\n\n/* Loading state */\n.verification-loading,\n.verification-ready,\n.verification-verifying {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 40px 20px;\n  text-align: center;\n}\n\n.spinner {\n  width: 40px;\n  height: 40px;\n  border: 3px solid #f0f0f0;\n  border-top: 3px solid #007bff;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: 20px;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* SAS Emoji Verification */\n.verification-sas-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.verification-sas-instructions {\n  margin-bottom: 30px;\n  font-size: 16px;\n  color: #666;\n  text-align: center;\n}\n\n.verification-sas-emojis {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(80px, 1fr));\n  gap: 15px;\n  width: 100%;\n  max-width: 400px;\n  margin-bottom: 30px;\n}\n\n.verification-sas-emoji {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 10px;\n  background: #f8f9fa;\n  border-radius: 8px;\n  transition: background-color 0.2s;\n}\n\n.verification-sas-emoji:hover {\n  background: #e9ecef;\n}\n\n.verification-sas-emoji .emoji {\n  font-size: 32px;\n  margin-bottom: 5px;\n}\n\n.verification-sas-emoji .name {\n  font-size: 12px;\n  color: #666;\n  text-align: center;\n}\n\n.verification-sas-actions {\n  display: flex;\n  gap: 10px;\n}\n\n/* QR Code Verification */\n.verification-qr-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n}\n\n.verification-qr-instructions {\n  margin-bottom: 20px;\n  font-size: 16px;\n  color: #666;\n}\n\n.verification-qr-code {\n  margin-bottom: 20px;\n}\n\n.qr-placeholder {\n  width: 256px;\n  height: 256px;\n  background: #f0f0f0;\n  border: 2px solid #ddd;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  color: #999;\n  font-size: 14px;\n}\n\n.verification-qr-alternative {\n  font-size: 14px;\n  color: #666;\n}\n\n/* Scan QR */\n.verification-scan-qr {\n  text-align: center;\n  padding: 40px 20px;\n}\n\n.verification-scan-qr input {\n  margin-top: 20px;\n  width: 100%;\n  max-width: 300px;\n  padding: 10px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 14px;\n}\n\n/* Complete/Error/Cancel states */\n.verification-complete,\n.verification-cancelled,\n.verification-error {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 40px 20px;\n  text-align: center;\n}\n\n.success-icon {\n  width: 60px;\n  height: 60px;\n  background: #28a745;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-size: 30px;\n  margin-bottom: 20px;\n}\n\n.warning-icon {\n  font-size: 48px;\n  margin-bottom: 20px;\n}\n\n.error-icon {\n  font-size: 48px;\n  margin-bottom: 20px;\n}\n\n.verification-error-message {\n  background: #f8d7da;\n  color: #721c24;\n  padding: 10px 15px;\n  border-radius: 4px;\n  margin-bottom: 20px;\n}\n\n/* Modal loading overlay */\n.verification-modal-loading {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(255, 255, 255, 0.9);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10;\n}\n\n/* Button styles */\n.btn {\n  padding: 10px 20px;\n  border: none;\n  border-radius: 4px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.btn-primary {\n  background: #007bff;\n  color: white;\n}\n\n.btn-primary:hover:not(:disabled) {\n  background: #0056b3;\n}\n\n.btn-secondary {\n  background: #6c757d;\n  color: white;\n}\n\n.btn-secondary:hover:not(:disabled) {\n  background: #545b62;\n}\n\n.btn-success {\n  background: #28a745;\n  color: white;\n}\n\n.btn-success:hover:not(:disabled) {\n  background: #218838;\n}\n\n.btn-danger {\n  background: #dc3545;\n  color: white;\n}\n\n.btn-danger:hover:not(:disabled) {\n  background: #c82333;\n}\n\n/* Dark theme support */\n@media (prefers-color-scheme: dark) {\n  .verification-modal {\n    background: #1e1e1e;\n    color: #e0e0e0;\n  }\n\n  .verification-modal-header {\n    border-bottom-color: #333;\n  }\n\n  .verification-modal-header h2 {\n    color: #e0e0e0;\n  }\n\n  .verification-modal-close {\n    color: #999;\n  }\n\n  .verification-modal-close:hover {\n    color: #fff;\n  }\n\n  .verification-modal-footer {\n    border-top-color: #333;\n  }\n\n  .verification-accept-screen h3 {\n    color: #e0e0e0;\n  }\n\n  .verification-accept-message {\n    color: #b0b0b0;\n  }\n\n  .verification-accept-message strong {\n    color: #fff;\n  }\n\n  .verification-accept-description {\n    color: #888;\n  }\n\n  .verification-sas-emoji {\n    background: #2a2a2a;\n  }\n\n  .verification-sas-emoji:hover {\n    background: #333;\n  }\n\n  .qr-placeholder {\n    background: #2a2a2a;\n    border-color: #444;\n    color: #666;\n  }\n\n  .verification-scan-qr input {\n    background: #2a2a2a;\n    border-color: #444;\n    color: #e0e0e0;\n  }\n\n  .verification-error-message {\n    background: #5a1e1e;\n    color: #f8d7da;\n  }\n\n  .verification-modal-loading {\n    background: rgba(30, 30, 30, 0.9);\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
